<div id="register-container">

    <div id="header-register">
        <h2>Formulario de registro</h2>
        <p>* Campos obligatorios</p>
    </div>

    <form [formGroup]="frmSignup" (submit)="createUser()" fxLayout="column" fxLayoutAlign="center">
        <mat-form-field>
            <input matInput type="text" formControlName="fullName" placeholder="Nombre Completo" />
        </mat-form-field>
        <label class="text-danger inputPrincipal" *ngIf="frmSignup.controls['fullName'].hasError('required')">
            ¡Necesitamos conocer tu nombre!
        </label>
        <mat-form-field>
            <input matInput type="text" formControlName="userName" placeholder="Nombre de Usuario" />
        </mat-form-field>
        <label class="text-danger inputPrincipal" *ngIf="frmSignup.controls['userName'].hasError('required')">
            ¡Necesitamos un nombre corto!
        </label>

        <mat-form-field>
            <input matInput formControlName="email" type="email" class="form-control" [ngClass]="frmSignup.controls['email'].invalid ? 'is-invalid' : ''" placeholder="Correo electrónico *">
        </mat-form-field>
        <label class="text-danger inputPrincipal" *ngIf="frmSignup.controls['email'].hasError('required')">
            ¡El correo es requerido!
        </label>
        <label class="text-danger inputPrincipal" *ngIf="frmSignup.controls['email'].hasError('email')">
            ¡El correo electronico no es valido!
        </label>

        <mat-form-field>
            <mat-label>Tipo de documento</mat-label>
            <mat-select formControlName="documentType" (selectionChange)="documentTypeSelection($event.value)">
                <mat-option *ngFor="let document of documentTypes" [value]="document.name">
                    {{document.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>

            <input matInput type="number" formControlName="document" placeholder="Documento de identificación *" (focusout)="verifyDocumentExists()" (focus)="disableSubmmit()" />
        </mat-form-field>
        <label class="text-danger inputPrincipal" *ngIf="frmSignup.controls['document'].hasError('required')">
            ¡Necesitamos Identificarte!
        </label>
        <div *ngIf="documentUsed">
            <label class="text-danger">
                <i class="material-icons">cancel</i>
                ¡Ya existe un usuario con ese documento!
            </label>
        </div>

        <mat-form-field>
            <input matInput [type]="passwordType" id="password" formControlName="password" class="form-control" [ngClass]="frmSignup.controls['password'].invalid ? 'is-invalid' : ''" placeholder="Contraseña *" />
            <i id="eye" class="material-icons" *ngIf="passwordShown === false, else elsePassEye" (click)="togglePassword()" align-self-center> </i>

            <ng-template #elsePassEye>
                <i id="eye-off" class="material-icons" (click)="togglePassword()" align-self-center> </i>
            </ng-template>
        </mat-form-field>

        <mat-form-field>
            <input matInput [type]="passwordType" id="confirmPassword" formControlName="confirmPassword" class="form-control" [ngClass]="frmSignup.controls['confirmPassword'].invalid ? 'is-invalid' : ''" placeholder="Repite la contraseña *" />
        </mat-form-field>

        <label class="text-danger repPass inputPrincipal" *ngIf="frmSignup.controls['confirmPassword'].hasError('required')">
            ¡Se requiere contraseña!
        </label>

        <label class="text-danger repPass inputPrincipal" *ngIf="frmSignup.controls['confirmPassword'].hasError('NoPassswordMatch')">
            ¡La contraseña no coincide!
        </label>


        <div id="requerimientos">
            <label [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                <i class="material-icons">
                    {{ frmSignup.controls['password'].hasError('required') ||
                    frmSignup.controls['password'].hasError('minlength') ? 'cancel' :
                    'check_circle' }}</i>
                ¡Debe tener al menos 6 caracteres!
            </label>
            <label [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                <i class="material-icons">{{ frmSignup.controls['password'].hasError('required') ||
                frmSignup.controls['password'].hasError('hasNumber') ? 'cancel' :
                'check_circle' }}</i>
                ¡Debe contener al menos 1 número!
            </label>
            <label [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                <i class="material-icons">{{ frmSignup.controls['password'].hasError('required') ||
                frmSignup.controls['password'].hasError('hasCapitalCase') ? 'cancel' :
                'check_circle' }}</i>
                ¡Debe contener al menos 1 en mayúscula!
            </label>
            <label [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                <i class="material-icons">{{ frmSignup.controls['password'].hasError('required') ||
                frmSignup.controls['password'].hasError('hasSmallCase') ? 'cancel' :
                'check_circle' }}</i>
                ¡Debe contener al menos 1 letra en minúscula!
            </label>
            <label [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                <i class="material-icons">{{ frmSignup.controls['password'].hasError('required') ||
                frmSignup.controls['password'].hasError('hasSpecialCharacters') ? 'cancel' :
                'check_circle' }}</i>
                ¡Debe contener al menos 1 caracter especial!
            </label>
        </div>

        <mat-checkbox id="isRefered" name="isRefered" formControlName="isRefered" [value]="isRefered" (change)="OnChekboxChange($event)">
            ¡Soy referido!
        </mat-checkbox>

        <mat-form-field *ngIf="isRefered">
            <input matInput formControlName="emailSponsor" type="email" class="form-control" placeholder="Correo electrónico de la persona que te refirió" (focusout)=verifySponsorExist(emailReferente) [(ngModel)]="emailReferente">
        </mat-form-field>

        <div *ngIf="isRefered" id="sponsor-requeriments">
            <label [ngClass]="sponsorVerified ? 'text-success' : 'text-danger'">
                <i class="material-icons">{{sponsorVerified ? 'check_circle': 'cancel' }}</i>
                ¡Se debe verificar el correo del patrocinador!
            </label>
        </div>

        <br>

        <mat-checkbox id="emailsOffert" name="isWantEmailsOffert" formControlName="emailOffers">Quiero recibir vía e-mail ofertas y novedades de Tugessi.com
        </mat-checkbox>

        <mat-checkbox id="termsAndConditions" name="isTermiAndCond" formControlName="termsAndConditions" [value]="termsAcepted" (change)="OnChekboxTemsCondChange($event)">
            Acepto los <a href="#">términos y condiciones</a> y autorizo el <a href="#">Tratamiento de datos
                personales</a>
        </mat-checkbox>

        <p> Tugessi.com cuenta con rigurosos estándares de seguridad. Todos tus datos se mantendrán en estricta confidencialidad. Ver politica de seguridad Si quieres dejar de recibir emails de Tugessi.com, puedes eliminar tu correo de nuestra lista automáticamente.</p>

        <div id="content-btn" fxLayout="row" fxLayoutAlign="space-around center">
            <a id="btn-cancelar" href="home">Cancelar</a>

            <button mat-raised-button color="primary" [disabled]="frmSignup.invalid || !sponsorVerified&&isRefered || !termsAcepted || documentUsed || !isValidDocument" type="submit" class="btn btn-primary btn-block font-weight-bold">Registrarse</button>
        </div>
    </form>
    <app-loader></app-loader>
</div>